import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header/Header';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useParams } from 'react-router-dom';

function DashboardBarLayout() {
  const darkTheme = createTheme({
    palette: {
      primary: {
        light: '#fff',
        main: '#3364E3',
        dark: '#fff',
        contrastText: '#fff',
      },
      mode: 'dark',
      background: {
        default: '#222226',
        paper: '#222226'
      }
    },
    components: {
      MuiButton: {
        styleOverrides: {
          // contained: {
          //   backgroundColor: '#4caf50',
          //   color: '#fff',
          //   '&:hover': {
          //     backgroundColor: '#388e3c',
          //   },
          // },
          outlined: {
            // borderColor: '#4caf50',
            color: '#fff',
            // '&:hover': {
            //   borderColor: '#388e3c',
            //   color: '#388e3c',
            // },
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            // color: '#4caf50', // màu label bình thường
            '&.Mui-focused': {
              color: '#fff', // màu label khi focus
            },
          },
        },
      },
    },
    typography: {
      fontFamily: 'Inter',
      fontSize: 14,
    },
  });

  const { projectId } = useParams();
  
  return (
    <ThemeProvider theme={darkTheme}>
      <div className={ projectId ? 'dashboard dashboard--project' : 'dashboard' }>
        <Header />
        <div className="dashboard__content">
          <div className="dashboard__content__inner">
            <Outlet />
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
}

export default DashboardBarLayout;